var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasWarnings
    ? _c("div", { staticClass: "msp-warnings-wrapper" }, [
        _c(
          "div",
          {
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.toggleWarnings.apply(null, arguments)
              },
            },
          },
          [
            _c("pui-icon", {
              attrs: {
                "icon-color": _vm.COLOR_RED,
                "icon-name": "icon-warning",
              },
            }),
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(_vm.numberWarnings) +
                  " " +
                  _vm._s(
                    _vm.numberWarnings.length === 1
                      ? _vm.$t("warning")
                      : _vm.$t("warnings")
                  ) +
                  " "
              ),
            ]),
            _c("pui-icon", {
              attrs: {
                "icon-color": _vm.COLOR_GREY,
                "icon-name": "icon-smallarrow-down",
                size: "2.4rem",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "pui-on-click-away",
                rawName: "v-pui-on-click-away",
                value: { callback: _vm.clickAway },
                expression: "{ callback: clickAway }",
              },
            ],
            ref: _vm.POPOVER_ANCHOR_REF,
            staticClass: "msp-warnings-wrapper__warnings",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.setShowWarnings.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "pui-popover",
              {
                ref: _vm.POPOVER_REF,
                attrs: {
                  "has-close-icon": false,
                  "anchor-ref": _vm.POPOVER_ANCHOR_REF,
                  headline: "",
                  position: "bottom",
                },
              },
              [
                _vm._l(
                  _vm.warningsData.overrunToleranceWarnings,
                  function (item, index) {
                    return _c(
                      "div",
                      {
                        key: "overrunToleranceWarnings-" + index,
                        staticClass: "msp-warnings-wrapper__warnings__details",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "msp-warnings-wrapper__warnings__details__section-title",
                          },
                          [_vm._v(" " + _vm._s(item.plantItemName) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "msp-warnings-wrapper__warnings__details__section-title__type",
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("exceededTolerance")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "msp-warnings-wrapper__warnings__details__section-item",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("driver") + ": ") +
                                " " +
                                _vm._s(item.driver) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "msp-warnings-wrapper__warnings__details__section-item",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("used") + ": ") +
                                " " +
                                _vm._s(item.usedLife) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "msp-warnings-wrapper__warnings__details__section-item",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("allowed") + ": ") +
                                " " +
                                _vm._s(item.allowed) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                _vm._l(
                  _vm.warningsData.noMaintenancePlannedWarnings,
                  function (item, index) {
                    return _c(
                      "div",
                      {
                        key: "noMaintenancePlannedWarnings-" + index,
                        staticClass: "msp-warnings-wrapper__warnings__details",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "msp-warnings-wrapper__warnings__details__section-title",
                          },
                          [_vm._v(" " + _vm._s(item.plantItemName) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "msp-warnings-wrapper__warnings__details__section-title__type",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("maintenanceNotPlanned")) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("calculatedMaintenance") + ": ") +
                              " " +
                              _vm._s(
                                _vm._f("puiFormatDateShort")(
                                  item.calculatedMaintenanceDate
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    )
                  }
                ),
              ],
              2
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }